// Import all transitions here
import defaultTransition from './transitions/default';

export default [defaultTransition];
